import type { ContactInfo } from '../types';

/** Geocoded: Vana-Sauga tn 42, Pärnu (Google Maps Geocoding) */
const mapLat = 58.3958029;
const mapLng = 24.4667558;
const mapsQuery = encodeURIComponent('Vana-Sauga 42, 800310 Pärnu, Estonia');
/** Street-level zoom for the exact workshop pin (Maps JS: isFractionalZoomEnabled) */
const mapZoom = 16.5;
const mapsCoords = `${mapLat},${mapLng}`;

export const contact: ContactInfo = {
  legalName: 'Lõdvik OÜ',
  brandName: 'Lõdvik — Autoremont',
  workshopAddressLines: ['Vana-Sauga 42'],
  postalCode: '800310',
  city: 'Pärnu',
  country: 'EE',
  phoneDisplay: '+372 5626 6798',
  phoneE164: '+37256266798',
  email: 'lodvikou@gmail.com',
  facebookUrl:
    'https://www.facebook.com/p/L%C3%B5dvik-o%C3%BC-61551416681972/',
  instagramUrl: 'https://www.instagram.com/lodvik_ou',
  // Lat/lng pins the exact workshop; z keeps the view street-close
  mapsUrl: `https://www.google.com/maps?q=${encodeURIComponent(mapsCoords)}&z=${Math.round(mapZoom)}`,
  /** Opens in Apple Maps app / maps.apple.com on Apple devices */
  appleMapsUrl: `https://maps.apple.com/?ll=${mapsCoords}&q=${mapsQuery}&z=${Math.round(mapZoom)}`,
  mapLat,
  mapLng,
  mapZoom,
  hoursDisplay: 'E–R 9:00–17:00',
  formWeekendNote:
    'Nädalavahetustel saadetud kirjad võivad vastuse alles järgneval nädalal saada.',
};

export function formatFullAddress(info: ContactInfo = contact): string {
  return `${info.workshopAddressLines.join(', ')}, ${info.postalCode} ${info.city}`;
}
